<mat-form-field>
    <mat-select [placeholder]="'Select a Location Set Type'">
        <mat-option
            *ngFor="let option of locationSetTypes$ | async"
            (click)="handleLocationSetTypeClick(option)"
            [value]="option">{{ option.name }}</mat-option>
    </mat-select>
</mat-form-field>
